export default "__VITE_ASSET__CkuLes0L__"